import { Type, Injectable, Input, OnInit, OnDestroy, ComponentRef } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { MapComponent, Coordinate, CoordinateBoundary, Marker } from '@realpage-da/ng-map';

import { ViewLevel } from '../constants';
import { PropertyDetail } from '~/core/model';

interface ViewParentComponent {
  searchResponse: Subject<Marker>;
  openPropertyModal: Subject<PropertyDetail>
  openLeaderboardModal: Subject<number>
  loadView(level: ViewLevel, center?: Coordinate, params?: any, zoom?: number): ViewParentComponent;
  updateLocationState(path: string, query?: string): void;
}

@Injectable()
export abstract class ViewComponent implements OnInit, OnDestroy {
  @Input() map: MapComponent;

  state: Observable<MapState>;

  static viewLevel: ViewLevel;

  abstract maxWidth: number;
  abstract halfWidth: number;

  onDestroy: Subject<ViewComponent> = new Subject();

  parent: ViewParentComponent;

  ngOnInit() { }

  ngOnDestroy() {
    this.onDestroy.next(this);
    this.onDestroy.complete();
  }
}

export interface MapState {
  bounds: CoordinateBoundary;
  zoom: number;
  params?: any;

  routeParams: ParamMap;

  sidebar?: 'closed' | 'open' | 'full';

  componentType?: ViewType;
  componentRef?: ComponentRef<ViewComponent>;
}

export type ViewType = Type<ViewComponent> & { viewLevel: ViewLevel };



// WEBPACK FOOTER //
// ./src/app/main/views/view.component.ts